
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  ref,
  Ref,
  watch
} from "vue";
import { Rating, RatingList } from "../../../../domain/entities/rating";
import { useStore } from "vuex";
import ContentComment from "./ContentComment.vue";
import { dispatchError } from "../../utils/error_handling";
import { Content } from "./helpers";
import { wrapLoading } from "../../utils/wrap_loading";
import { updateQuery } from "../../utils/routing_utils";
import { useRouter } from "vue-router";
import { fastKey } from "core-js/internals/internal-metadata";

export default defineComponent({
  name: "RatingList",
  methods: { fastKey },
  components: { ContentComment },
  setup() {
    const store = useStore();
    const router = useRouter();

    const allRatings: Ref<Rating[]> = ref([]);

    const ratingsList: ComputedRef<RatingList> = computed(
      () => store.getters["content_module/rating/ratings"]
    );

    onBeforeMount(async () => {
      await onCurrentContentChange();
    });

    const currentContent: ComputedRef<Content> = computed(
      () => store.getters["content_module/currentContent"]
    );

    watch(
      () => currentContent.value,
      async () => {
        await onCurrentContentChange();
      }
    );

    const onCurrentContentChange = async () => {
      try {
        await cleanRatingsState();
        await loadRatings(0);
      } catch (e) {
        console.error("[onCurrentContentChange] Error loadRatings");
        await dispatchError(e);
      }
    };

    const loadRatings = async (index?: number): Promise<void> => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("content_module/rating/loadRatings", index);
        });
        await updateQuery(router, "index", index ? index.toString() : "0");
      } catch (e) {
        console.error("[loadRatings] Error dispatch ", e);
        throw e;
      }
    };

    const cleanRatingsState = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/rating/clearRatings");
      } catch (e) {
        console.error("[cleanRatingsState] Error dispatch ", e);
        throw e;
      }
    };

    return {
      currentContent,
      allRatings,
      ratingsList,
      loadRatings
    };
  }
});
